const generateYearMonth = (monthsBack = 12) => {
  const current = new Date()
  const yearMonth: { [key: string]: string } = {}

  for (let i = 0; i < monthsBack; i++) {
    const year = current.getFullYear()
    const month = (current.getMonth() + 1).toString().padStart(2, "0")
    const key = `${year}-${month}`
    const value = `${year}年${month}月`
    yearMonth[key] = value

    current.setMonth(current.getMonth() - 1)
  }

  return yearMonth
}
export const DATE_PERIODS = generateYearMonth()

export const DATE_PERIOD_DEFAULT = Object.values(DATE_PERIODS)[0]

export type DatePeriod = (typeof DATE_PERIODS)[keyof typeof DATE_PERIODS]

export const getDatePeriodParam = (value: DatePeriod): string => {
  return (
    Object.keys(DATE_PERIODS).find(key => DATE_PERIODS[key] === value) ??
    DATE_PERIOD_DEFAULT
  )
}
